<script setup lang="ts">
    import EventEditorIssueConfirmations, { type IssueConfirmation } from '@views/Event/EventEditor/EventEditorIssueConfirmations.vue';
    import { TestSendStatus } from '@views/Event/EventConfirmationContent.vue';
    import { addDefaultConfirmationIssue, deleteParticipantStatusIssue } from '@views/Event/Event.access';

    defineProps<{
        eventId: string;
    }>();

    const confirmations: IssueConfirmation[] = [
        {
            title: $Resources.EventAcceptConfirmationHeader,
            description: $Resources.EventAcceptConfirmationDescription,
            contentTitle: $Resources.EventMessageToAcceptHeader,
            subjectKey: 'ConfirmationSubject',
            textKey: 'ConfirmationText',
            status: TestSendStatus.Accepted,
        },
        {
            title: $Resources.EventConfirmationsToGuestsInQueue,
            description: $Resources.EventConfirmationsToGuestsInQueueDescription,
            contentTitle: $Resources.EventMessageToQueuedGuests,
            subjectKey: 'WaitlistSubject',
            textKey: 'WaitlistText',
            status: TestSendStatus.Waitlist,
        },
        {
            title: $Resources.EventCancellationConfirmation,
            description: $Resources.EventCancellationConfirmationDescription,
            contentTitle: $Resources.EventMessageToCancelledGuests,
            subjectKey: 'CancellationSubject',
            textKey: 'CancellationText',
            status: TestSendStatus.Cancelled,
        },
    ];
</script>

<template>
    <EventEditorIssueConfirmations
        :eventId="eventId"
        issueIdKey="ParticipantStatusChangeIssueId"
        :confirmations="confirmations"
        newIssueQueryKey="participantStatusChangeIssue"
        :addDefaultIssue="addDefaultConfirmationIssue"
        :deleteIssue="deleteParticipantStatusIssue"
        :heading="$Resources.EventConfirmationsHeader"
        :description="$Resources.EventConfirmationsDescription"
        :missingHeading="$Resources.EventMissingConfirmationHeading"
        :missingText="$Resources.EventMissingConfirmationText"
        :missingStandardBtnText="$Resources.EventMissingConfirmationStandardBtnText"
        :missingCustomBtnText="$Resources.EventMissingConfirmationCustomBtnText" />
</template>
